// extracted by mini-css-extract-plugin
export default {"drawer":"XzocR7Ipayow7PuhvFmM","expandIcon":"sMGZL00NUixqTxgCGPdV","accordion":"ioApFjVQ9mBuqPsjrpFM","panel":"yqNO3WnKupQyfCGYVWFn","description":"t2nyKDYFooqtWjXoORau"};